import React from 'react';
import NavLink from '../NavLink';
import { announcementsPath } from 'utils/paths';
import CartNavLink from './CartNavLink';
import styles from './styles.scss';
import enhance from './enhance';

export const text = {
  altAlertIcon: 'Alert Icon',
  altCartIcon: 'Cart Icon',
};

export const NavLinks = ({ inCart, alertIcon }) => (
  <nav>
    <ul className={styles.container}>
      <NavLink to={announcementsPath}>
        <div className={styles.navIcon}>
          <img alt={text.altAlertIcon} src={alertIcon} />
        </div>
      </NavLink>
      <CartNavLink />
    </ul>
  </nav>
);

export default enhance(NavLinks);
